import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const sqlConfigurationService = {
  getSqlDbType: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_SQL_DBTYPE,
        method: 'GET',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get SQL database type error:', error);
      throw error;
    }
  },
  getDB: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_DB,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get database error:', error);
      throw error;
    }
  },
  getDBInfo: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_DB_INFO,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get group by ID error:', error);
      throw error;
    }
  },
  getConnectionstring: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_CONNECTION_STRING,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get connection string error:', error);
      throw error;
    }
  },
  getSQLConfigByCompanyId: async (companyID) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_SQL_CONFIG_BY_COMPANY,
        method: 'POST',
        data: { companyID },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get SQL config by company ID error:', error);
      throw error;
    }
  },
  saveSQLConfig: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.SAVE_SQL_CONFIG,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Save SQL configuration error:', error);
      throw error;
    }
  },
  updateSQLConfig: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_SQL_CONFIG,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update SQL configuration error:', error);
      throw error;
    }
  }
};
